import { call } from 'redux-saga/effects';
import { Modal } from 'antd';
import { TourTicket } from '../models/Tour';
import * as TourService from '../services/tourService';

export function getTranslationsToCopy(translations, languageCode) {
    const seen = new Set();
    return (translations || []).filter(translation => {
        const code = translation.languageCode;
        if (!code || code === languageCode || seen.has(code)) return false;
        seen.add(code);
        return true;
    });
}

export function makeTranslationTicket(ticket, translation) {
    const model = new TourTicket({
        id: ticket.id,
        name: translation.name,
        description: translation.description,
        extraInfos: translation.extraInfos,
        code: ticket.code,
        property: ticket.property,
    }, true);
    model.languageCode = translation.languageCode;
    model.translate = {};
    return model;
}

function confirmRetry(failed) {
    return new Promise(resolve => Modal.confirm({
        title: 'Vé đã được tạo, nhưng chưa sao chép đủ bản dịch',
        content: `Ngôn ngữ còn thiếu: ${failed.map(item => item.languageCode).join(', ')}. Thử lại chỉ bổ sung bản dịch, không tạo thêm vé.`,
        okText: 'Thử lại',
        cancelText: 'Để sau',
        onOk: () => { resolve(true); },
        onCancel: () => { resolve(false); },
    }));
}

export function* copyTourTicketTranslations(ticket, translations, languageCode) {
    let pending = getTranslationsToCopy(translations, languageCode);
    while (pending.length) {
        const failed = [];
        for (const translation of pending) {
            try {
                yield call(TourService.createDetailTourTicketTranslate, makeTranslationTicket(ticket, translation));
            } catch (error) {
                failed.push(translation);
            }
        }
        if (!failed.length) return true;
        if (!(yield call(confirmRetry, failed))) return false;
        // A timed-out POST may have succeeded on the server. Check before retrying.
        let existing;
        while (!existing) {
            try {
                existing = yield call(TourService.getDetailTourTicketDetail, ticket.id);
            } catch (error) {
                if (!(yield call(confirmRetry, failed))) return false;
            }
        }
        pending = failed.filter(item => !existing.translations.some(saved => saved.languageCode === item.languageCode));
    }
    return true;
}
